import React from 'react'
import Link from 'gatsby-link'

import binance from "./binance.png"
import bitfinex from "./bitfinex.png"
import bitstamp from "./bitstamp.png"
import bittrex from "./bittrex.png"
import coinbase from "./coinbase.png"
import cex from "./cex.png"
import hitbtc from "./hitbtc.png"
import kraken from "./kraken.png"
import luno from "./luno.png"
import poloniex from "./poloniex.png"
import cryptopia from "./cryptopia.png"
import kucoin from "./kucoin.png"
import huobi from "./huobi.png"

import './index.css'

const Exchanges = () => (
  <ul className="exchanges-images">
    <li><img src={binance} alt="Binance" title="Binance: Import via API and CSV" /></li>
    <li><img src={bitfinex} alt="Bitfinex" title="Bitfinex: Import via API and CSV" /></li>
    <li><img src={bitstamp} alt="Bitstamp" title="Bitstamp: Import via API" /></li>
    <li><img src={bittrex} alt="Bittrex" title="Bittrex: Import via API and CSV" /></li>
    <li><img src={cex} alt="Cex" title="CEX: Import via API" /></li>
    <li><img src={coinbase} alt="Coinbase" title="Coinbase: Import via API and CSV" /></li>
    <li><img src={cryptopia} alt="Cryptopia" title="Cryptopia: Import via API and CSV" /></li>
    <li><img src={hitbtc} alt="HitBTC" title="HitBTC: Import via API and CSV" /></li>
    <li><img src={huobi} alt="Huobi" title="Huobi: Import via API" /></li>
    <li><img src={kraken} alt="Kraken" title="Kraken: Import via API and CSV" /></li>
    <li><img src={kucoin} alt="KuCoin" title="KuCoin: Import via API and CSV" /></li>
    <li><img src={luno} alt="Luno" title="Luno: Import via API and CSV" /></li>
    <li><img src={poloniex} alt="Poloniex" title="Poloniex: Import via API and CSV" /></li>
  </ul>
)

export default Exchanges



// WEBPACK FOOTER //
// ./src/components/Exchanges/index.js